import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import StudentFilterForm from './FilterForm';
import {
  reporteAlumnosFormData,
  reporteAlumnos,
  downloadStudents,
} from '../../redux/actions/studentsActions';
import { createErrorMessage } from '../../helpers/notification';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import { dateDDMMYYFormat } from '../../helpers/dateFormat';
import {
  Generos,
} from '../../constants/enums';

class StudentsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.handleOnFilterChange = this.handleOnFilterChange.bind(this);
    this.downloadAlumnos.bind(this);
    this.state = {
      page: 1,
      pageSize: 100,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 0 },
    };
    this.columns = [
      { key: 'numeroDocumento', name: 'C.I. Nº', width: '120px' },
      { key: 'apellido', name: 'Apellido' },
      { key: 'nombre', name: 'Nombre' },
      { key: 'edad', name: 'Edad' },
      { key: 'nacionalidad', name: 'Nacionalidad' },
      {
        key: 'arancelCero',
        name: 'Arancel Cero',
        type: 'number',
        className: 'text-center',
        format: row => (row.arancelCero ? 'Si' : 'No'),
      },
      {
        key: 'fechaFinArancelCero',
        name: 'Fin Arancel Cero',
        type: 'number',
        className: 'text-center',
        format: row => (row.arancelCero ? dateDDMMYYFormat(row.fechaFinArancelCero) : ''),
      },
      { key: 'phoneNumber', name: 'Teléfono' },
      { key: 'email', name: 'Correo' },
      {
        key: 'genero',
        name: 'Género',
        format: row => (Generos[row.genero] ? Generos[row.genero].label : ''),
      },
      {
        key: 'fechaIngreso',
        name: 'Año Ingreso',
        type: 'number',
        format: row => new Date(row.fechaIngreso).getFullYear(),
      },
      { key: 'carrera', name: 'Carrera' },
      {
        key: 'semestre',
        name: 'Semestre',
        format: row => `${row.semestre}º`,
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.fetchFormData(page, pageSize);
    this.setState({
      loading: false,
    });
  }

  fetchFormData = () => {
    reporteAlumnosFormData({
      onSuccess: (formData) => {
        const { materias } = formData;
        // Filter distinct and use MateriaId
        const distinctMaterias = materias
          .filter((v, index, self) => self.map(x => x.label).indexOf(v.label) === index)
          .map(x => ({ label: x.label, value: x.materiaId }));
        this.setState({
          ...formData,
          todasLasMaterias: materias,
          materias: distinctMaterias,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar los datos del formulario');
      },
    });
  }

  updateStudentsTable = (page, pageSize, filters) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });
    reporteAlumnos({
      pageInfo: {
        page,
        pageSize,
        filters: filters || {},
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de alumnos');
      },
    });
  }

  handleOnFilterChange = (objectKey, idKey, value) => {
    if (objectKey === 'periodo' || objectKey === 'carrera') {
      const { carreraId, periodoId, todasLasMaterias } = this.state;

      const newCarreraId = objectKey === 'carrera' ? value.value : carreraId;
      const newPeriodoId = objectKey === 'periodo' ? value.value : periodoId;

      let materias = todasLasMaterias.filter(m => (!newCarreraId || m.carreraId === newCarreraId)
        && (!newPeriodoId || m.periodoId === newPeriodoId));

      materias = materias.filter((v, index, self) => self.map(x => x.label).indexOf(v.label) === index);

      this.setState({
        [idKey]: value.value,
        [objectKey]: value,
        materias,
      });
    } else {
      this.setState({
        [idKey]: value.value,
        [objectKey]: value,
      });
    }
    const { filters } = this.state;
    filters[idKey] = value.value;

    this.setState({
      filters,
    });
  }

  handleOnFilter = () => {
    const { page, pageSize, filters } = this.state;
    this.updateStudentsTable(page, pageSize, filters);
  }

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateStudentsTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateStudentsTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateStudentsTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  downloadAlumnos = () => {
    const { filters } = this.state;
    downloadStudents({
      filters: filters || {},
      onError: () => {
        createErrorMessage('Error al intentar descargar la lista de alumnos');
      },
    });
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    }

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Reporte de alumnos</h3>
          </Col>
        </Row>
        <Row>
          <StudentFilterForm
            {...this.state}
            onFilterChanges={this.handleOnFilterChange}
            onFilter={this.handleOnFilter}
          />
        </Row>
        {items.length && (
          <Row>
            <Col md={12} className="text-right">
              <button
                className="btn btn-link"
                type="button"
                onClick={this.downloadAlumnos}
              >
                <span className="fa fa-cloud-download">&nbsp;</span>
                Descargar lista
              </button>
            </Col>
          </Row>
        )
        }
        <Row>
          <DataTable
            title="Reporte de los alumnos"
            columns={this.columns}
            items={items}
            onChangePage={this.onChangePage}
            page={page}
            pageSize={pageSize}
            totalItemsCount={totalItemsCount}
            onSubmit={this.onDataTableSubmit}
            onClearFilters={this.onDataTableClearFilters}
            initialValues={filters}
            enableReinitialize
          />
        </Row>
      </Container>
    );
  }
}

export default withRouter(StudentsContainer);
